/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropmessagewinner2Inputs */

const en_dropmessagewinner2 = /** @type {(inputs: Dropmessagewinner2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message winner`)
};

const de_dropmessagewinner2 = /** @type {(inputs: Dropmessagewinner2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gewinner anschreiben`)
};

/**
* | output |
* | --- |
* | "Message winner" |
*
* @param {Dropmessagewinner2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropmessagewinner2 = /** @type {((inputs?: Dropmessagewinner2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropmessagewinner2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropmessagewinner2(inputs)
	return de_dropmessagewinner2(inputs)
});
export { dropmessagewinner2 as "dropMessageWinner" }